import { ArrowBackOutlined } from '@mui/icons-material'
import { Box, IconButton, Tab, Tabs, Typography } from '@mui/material'
import ProjectsContainer from '../../projects'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { useState } from 'react';
import DashboardContainer from '../dashboard';
import ProgramContainer from '../../program';

const Local_Tabs = {
    dashboard: "Dashboard",
    list: "List of Project",
}


function ActiveOrganisationContainer() {
    const { currentProgramData, setCurrentProgramData } = useApplicationContext();

    const [activeTab, setActiveTab] = useState(Local_Tabs.dashboard);

    const handleComponent = (value) => {
        switch (value) {
            case Local_Tabs.dashboard: return <DashboardContainer />;
            case Local_Tabs.list: return <ProgramContainer />;
            default: return null;
        }
    }

    const handleCloseItem = () => {
        setCurrentProgramData(null);
    }

    const handleChangeTabs = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box className="flex-1 flex flex-col">

            {/* header */}
            <Box className="flex items-center px-4 py-2">
                <Box className="flex-1 flex items-center gap-2">
                    <IconButton color="secondary" onClick={handleCloseItem}>
                        <ArrowBackOutlined />
                    </IconButton>
                    <Box className="flex flex-col">
                        <Typography fontWeight={"bold"}>Organisation Name</Typography>
                        <Typography>Description of the organisation</Typography>
                    </Box>
                </Box>



                {/* <Tabs
                    value={activeTab}
                    onChange={handleChangeTabs}
                    aria-label="basic tabs example"
                    textColor="secondary"
                    indicatorColor="secondary"
                >
                    {
                        Object.keys(Local_Tabs).map((key, index) => (
                            <Tab label={Local_Tabs[key]} value={Local_Tabs[key]} />
                        ))
                    }
                </Tabs> */}
            </Box>

            {/* main container */}
            <Box className="flex-1 flex flex-col overflow-y-auto">
                {handleComponent(activeTab)}
            </Box>
        </Box>
    )
}

export default ActiveOrganisationContainer
